import {IconButton, Tooltip, Typography} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function AdTypeToolTip(){
    return <Tooltip style={{"marginTop": ".25em"}} title={
                    <Typography>
                        <b><u>On</u></b> - ad will be available to serve. <br/><br/>
                        <b><u>Fixed</u></b> - ad will be served based on current quota. If no quota is present the ad will not serve. <br/><br/>
                        <b><u>Off</u></b> - ad will not be available to serve. <br/><br/>
                        <b><u>Draft</u></b> - ad will not be available to serve. Indicates there's still work left to do. <br/><br/>
                        <b><u>Archive</u></b> - ad will be removed from the UI. Closest we have to delete. <br/><br/>
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
}